import axios from "axios";
import { IotKeyDevice } from "../../interfaces/IoKeyDeviceInterface";

const perPage = 60;

export const getIoTKeyDevices = async (
  page = 1,
  cancelToken,
  filterBy = "",
  sortBy = "",
) => {
  let url = `${process.env.REACT_APP_VEHICLES_API}/iot_devices?results_per_page=${perPage}&page=${page}`;
  if (filterBy) {
    url = `${url}&${filterBy}`;
  }
  if (sortBy) {
    url = `${url}&${sortBy}`;
  }
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return { details: e.response?.data?.details };
  }
};

export const deleteIoTDevice = async (iotKeyID) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "delete",
      url: `${process.env.REACT_APP_VEHICLES_API}/iot_devices/${iotKeyID}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response };
  } catch (e) {
    if (e.response.data.code === 120) {
      return {
        detail: "Cannot delete IoT device before deleting connected vehicle",
      };
    }
    return { detail: e.response.data.details };
  }
};

export const getIoTKeyDevice = async (id: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  let url = `${process.env.REACT_APP_VEHICLES_API}/iot_devices/${id}`;
  try {
    const response = await axios({
      method: "get",
      url,
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (e) {
    return { details: e.response?.data?.details };
  }
};

export const createIoTKeyDevice = async (
  company_id,
  iot_key_id,
  ble_device_type,
  mac_address,
  firmware_version,
  hardware_version,
  firmware_config_file?,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  let url = `${process.env.REACT_APP_VEHICLES_API}/iot_devices`;
  const response = await axios({
    method: "post",
    url,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      company_id,
      iot_key_id,
      ble_device_type: ble_device_type || null,
      mac_address: mac_address || null,
      firmware_version,
      hardware_version,
      firmware_config_file,
    },
  });
  return response.data;
};

export const updateIoTKeyDevice = async ({
  created,
  modified,
  _id,
  company_id,
  iot_key_id,
  ble_device_type,
  mac_address,
  firmware_version,
  hardware_version,
  firmware_config_file,
  vehicle_id,
}: IotKeyDevice) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  let url = `${process.env.REACT_APP_VEHICLES_API}/iot_devices/${_id}`;
  const response = await axios({
    method: "put",
    url,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      created,
      modified,
      _id,
      company_id,
      iot_key_id,
      ble_device_type: ble_device_type || null,
      mac_address: mac_address || null,
      firmware_version,
      hardware_version,
      firmware_config_file,
      vehicle_id,
    },
  });
  return {
    data: response.data,
  };
};

export const getIoTKeyDeviceConfigFileUrl = (
  setState: (v: any) => void,
  file: any,
  id: string,
): void => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  let url = `${process.env.REACT_APP_VEHICLES_API}/iot_devices/${id}/upload_firmware_config/bin`;

  axios({
    method: "get",
    url,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      setState({
        firmware_config_file:
          response.data.data.url + response.data.data.fields.key,
      });
      const options = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const data = new FormData();
      Object.keys(response.data.data.fields).forEach((key) =>
        data.append(key, response.data.data.fields[key]),
      );
      data.append("file", file);
      axios.post(response.data.data.url, data, options);
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const importIotKeyDevices = async (devices) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_VEHICLES_API}/iot_devices/import`,
      headers: { Authorization: `Bearer ${token}` },
      data: devices,
    });
    return response;
  } catch (e) {
    return { e };
  }
};
